// import { useMediaQuery } from "react-responsive";
import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import { Helmet } from "react-helmet-async";
import { ContentWrapper } from "../loading/LoadingSkeleton";
import { API_URL } from "../../config";

// import Container from 'react-bootstrap/Container';
// import Row from 'react-bootstrap/Row';
// import Col from 'react-bootstrap/Col';

// ProgrammaTile component for individual fade-in animation
function ProgrammaTile({ programma }) {
	const [imageLoaded, setImageLoaded] = useState(false);
	const [imageSrc, setImageSrc] = useState('');

	useEffect(() => {
		const thumbnail = programma.attributes.cover?.data?.attributes?.formats?.thumbnail?.url;
		const medium = programma.attributes.cover?.data?.attributes?.formats?.medium?.url;
		
		if (thumbnail) {
			setImageSrc(thumbnail);
			if (medium && medium !== thumbnail) {
				const img = new Image();
				img.onload = () => setImageSrc(medium);
				img.src = medium;
			}
		} else if (medium) {
			setImageSrc(medium);
		}
	}, [programma]);

	return (
		<div 
			className='progs-container' 
			style={{
				opacity: imageLoaded ? 1 : 0,
				transition: 'opacity 0.2s ease-in-out'
			}}
		>
			<Link className="progs-image" to={programma.attributes.slug}>
				<img
					src={imageSrc}
					alt={"Foto voorprogramma " + programma.attributes.title}
					loading="lazy"
					onLoad={() => setImageLoaded(true)}
				/>
			</Link>
			<div className='progs-details'>
				<Link to={programma.attributes.slug}>
					<h3 className='progs-details-title'>
						{programma.attributes.title}
					</h3>
				</Link>
				{programma.attributes.films.data.length <= 5 &&
					programma.attributes.films.data.map((programmafilm) => (
						<Link
							className='progsfilms-details'
							to={"/films/" + programmafilm.attributes.productionid}
							key={programmafilm.attributes.productionid}
						>
							<p>{programmafilm.attributes.titel}</p>
						</Link>
					))
				}
				{programma.attributes.films.data.length > 5 &&
					programma.attributes.films.data.slice(0, 6).map((programmafilm) => (
						<Link
							className='progsfilms-details'
							to={"/films/" + programmafilm.attributes.productionid}
							key={programmafilm.attributes.productionid}
						>
							<p>{programmafilm.attributes.titel}</p>
						</Link>
					))
				}
				{programma.attributes.films.data.length > 6 && (
					<Link className='progsfilms-details' to={programma.attributes.slug}>...</Link>
				)}
			</div>
		</div>
	);
}

export default function Programmas() {
	const [programmas, setProgrammas] = useState([]);
	const [loading, setLoading] = useState(true);
	const isMobile = useMediaQuery({ query: "(max-width: 991px)" });

	useEffect(() => {
		const loadData = async () => {
			try {
				// Check cache first
				const cacheKey = 'kriterion-programmas-data';
				const cacheTimeKey = 'kriterion-programmas-data-time';
				const cachedData = localStorage.getItem(cacheKey);
				const cacheTime = localStorage.getItem(cacheTimeKey);
				
				if (cachedData && cacheTime && (Date.now() - parseInt(cacheTime)) < 300000) {
					setProgrammas(JSON.parse(cachedData));
					setLoading(false);
					return;
				}

				const response = await axios.get(
					`${API_URL}/api/programmas?populate=*&sort[0]=createdAt:desc`
				);
				
				const data = response.data.data;
				localStorage.setItem(cacheKey, JSON.stringify(data));
				localStorage.setItem(cacheTimeKey, Date.now().toString());
				
				setProgrammas(data);
				setLoading(false);
			} catch (error) {
				console.error('Error loading programmas:', error);
				setLoading(false);
			}
		};

		loadData();
	}, []);

	return (
		<ContentWrapper isLoading={loading} loadingMessage="Programma's worden geladen...">
			<div className='body-container'>
				<Helmet>
					<title>Filmprogramma's - Filmtheater Kriterion Amsterdam</title>
					<meta name="description" content="Ontdek filmprogramma's en thematische filmreeksen in Filmtheater Kriterion Amsterdam." />
				</Helmet>
				{!isMobile && <h2 className="desktop-titel desktop-programmas-titel">Filmprogramma's</h2>}
				{programmas.map((programma) => (
					<ProgrammaTile key={programma.attributes.slug} programma={programma} />
				))}
			</div>
		</ContentWrapper>
	);
}
